import React, {useEffect, useState} from 'react';
import {
    CardBody, Col,Form, FormGroup, Input, Label, Row,
} from 'reactstrap';

import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";
import { FL_CODE, FL_COUPON, FL_ONLY_REGISTERED, FL_STATUS} from "../../../components/i18n/formLabels";
import {PH_SEARCH_CODE, PH_SEARCH_COUPON} from "../../../components/i18n/placeHolders";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

const PromotionControllerFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { filter, app } = componentState?.data;

    const fbDataBaseId = app?.fbDataBase?.id
    const [status, setStatus] = useState( filter?.item?.status ?? true);
    const [preferent, setPreferent] = useState(filter?.item?.topPreference ?? null);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    // useEffect(() => {
    //     console.log('useEffect.filter')
    //     if (!componentState)
    //         return;
    //
    //     console.log( componentState);
    // }, [componentState]);

    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
            code: filter?.item?.code,
            coupon: filter?.item?.coupon
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            onlyRegistered : onlyRegistered ? onlyRegistered : null,
            item : {
                code: data.code,
                coupon: data.coupon,
            }
        }

        if (status !== undefined && status !== null) {
            dataFilter.item.status = status;
        }

        if (preferent !== undefined && preferent !== null) {
            dataFilter.item.topPreference = preferent;
        }

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))

        setStatus(null);
        setOnlyRegistered(null);
        setPreferent(null);
        reset({
            code: '',
            coupon: ''
        });

        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.onlyRegistered;
            delete tmpFilter.item.code;
            delete tmpFilter.item.coupon;
            delete tmpFilter.item.status;
            delete tmpFilter.item.topPreference;
        }
        props.setFilter(tmpFilter);
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_CODE}</Label>
                            <Input type="text" name="code"
                                   placeholder={PH_SEARCH_CODE}
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_COUPON}</Label>
                            <Input type="text" name="coupon"
                                   placeholder={PH_SEARCH_COUPON}
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    innerRef={register}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Promoción top?'}</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={preferent}
                                    innerRef={register}
                                    onChange={_ => setPreferent(!preferent)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_ONLY_REGISTERED}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(PromotionControllerFilters)
